import React from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';

// import {defineMessages} from 'react-intl';
import {LocalizedDocumentMeta} from 'shared/LocalizedDocumentMeta.jsx';

import Menu from '../menu/preMatch/Menu.jsx';
import Sports from '../menu/preMatch/Sports.jsx';
import Sport from '../menu/preMatch/Sport.jsx';
import League from '../menu/preMatch/League.jsx';

import StreamPanel from '../stream/StreamPanel.jsx';

import Banner from '../main-page/Banner.jsx';
import Popular from '../main-page/banners/popular/Popular.jsx';
import News from '../main-page/banners/news/News.jsx';
import BetPanel from '../bet-panel-control/BetPanel.jsx';

import {stopFetchStream as stopFetchStreamAction} from 'actions/creators/Stream';

import {initPreMatchMenu as initPreMatchMenuAction} from 'actions/creators/PreMatchMenu';
import {getNews as getNewsAction} from 'actions/creators/News';
import {fetchPopularMatches as getPopularMatchesAction} from 'actions/creators/Popular';

import {toggleSportMain as toggleSportMainAction} from 'actions/creators/UserSelection';
import { getMetadata } from '../../../shared/metadata/metadata'

// const messages = defineMessages({
//     title: {
//         id: 'pages.main.title',
//         defaultMessage: 'Ставки на спорт онлайн. Букмекерская контора FairPlay в Казахстане.'
//     },
//     description: {
//         id: 'pages.main.description',
//         defaultMessage: 'Круглосуточно принимаем ставки в режиме онлайн на все спортивные события' +
//             ' с высокими коэффициентами: футбол, теннис, баскетбол, волейбол, ' +
//             'хоккей, бокс, борьба, плавание, лыжи.'
//     }
// });

class MainPage extends React.Component {
    static propTypes = {
        languageId: React.PropTypes.number.isRequired,
        news: React.PropTypes.array,
        gridSelection: React.PropTypes.object.isRequired,
        gridLocalization: React.PropTypes.object.isRequired,
        stream: React.PropTypes.object.isRequired,
        initPreMatchMenuAction: React.PropTypes.func.isRequired,
        getPopularMatchesAction: React.PropTypes.func.isRequired,
        toggleSportMainAction: React.PropTypes.func.isRequired,
        push: React.PropTypes.func.isRequired,
        getNewsAction: React.PropTypes.func.isRequired,
        stopFetchStreamAction: React.PropTypes.func.isRequired
    };

    static contextTypes = {
        footer: React.PropTypes.object
    };

    constructor(props, context) {
        super(props, context);

        this._menuShowAll = this._menuShowAll.bind(this);
        this._sportClick = this._sportClick.bind(this);
        this._leagueClick = this._leagueClick.bind(this);
    }

    componentWillMount() {
        const languageId = this.props.languageId;

        // this.props.getNewsAction(languageId);
        this.props.getPopularMatchesAction({languageId});
        this.props.initPreMatchMenuAction({languageId});
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.languageId !== nextProps.languageId) {
            // this.props.getNewsAction(nextProps.languageId);
            this.props.getPopularMatchesAction({languageId: nextProps.languageId});
            this.props.initPreMatchMenuAction({languageId: nextProps.languageId});
        }
    }

    _menuShowAll() {
        this.props.push(`/sports`);
    }

    _sportClick(id) {
        this.props.push(`/sports/${id}`);
    }

    _leagueClick(sportId, id) {
        return this.props.push(`/sports/${sportId}/${id}`);
    }

    render() {
        const {toggleSportMainAction, gridSelection, news, gridLocalization, countryCode, stream, user, streamName, matchIsBlocked, params} = this.props;

        const menuProps = {
            showSlider: false,
            showBookmarks: false,
            showCalendar: false,
            showMatches: false,
            sportsElement: Sports,
            sportElement: Sport,
            leagueElement: League,
            showAllSports: false,
            gridSelection: gridSelection,
            showAllCallback: this._menuShowAll,
            sportClickCallback: this._sportClick,
            leagueClickCallback: this._leagueClick,
            selectionToggleCallback: toggleSportMainAction,
            selectionToggleLeagueCallback: null,
            isShortcut: false
        };

        const newsProps = {
            news
        };

        const metadata = getMetadata(countryCode, params.sportId);

        return (
            <div className='no-scroll-wrapper'>
                <LocalizedDocumentMeta title={metadata.title} description={metadata.description} keywords={metadata.keywords}/>
                <div id="left" className='main-left'>
                    <Menu {...menuProps} />
                </div>
                <div id="right">
                    {(user && !matchIsBlocked && stream.src) && <StreamPanel stream={stream}
                                                stopFetchStreamAction={this.props.stopFetchStreamAction}
                                                streamName={streamName}
                                                user={user}/>}
                    <BetPanel/>
                </div>
                <div id="center">
                    <Banner />
                    <Popular gridLocalization={gridLocalization} />
                    {countryCode !== 'KG' && <News {...newsProps} />}
                    {this.context.footer}
                </div>
            </div>
        );
    }
}

function select(state) {
    const languageId = state.application.get('languageId');
    const countryCode = state.application.get('countryCode');
    const news = state.application.get('news');
    const gridSelection = state.application.getIn(['userGridSelection', 'main']);
    const user = state.auth.get('user');
    const stream = state.application.get('stream');

    const match = state.application.getIn(['popularMatches', 'matches', state.application.get('stream').matchId]);

    let matchIsBlocked = false;
    let streamName = '';
    if (match) {
        matchIsBlocked = match.get('isBlocked');
        streamName = match.get('name') ? match.get('name') : '';
    }

    return {
        languageId,
        countryCode,
        news,
        gridSelection,
        stream,
        user,
        streamName,
        matchIsBlocked
    };
}

export default connect(select, {
    initPreMatchMenuAction,
    getNewsAction,
    getPopularMatchesAction,
    toggleSportMainAction,
    push,
    stopFetchStreamAction
})(MainPage);



// WEBPACK FOOTER //
// ./js/sport-betting/components/pages/MainPage.jsx